import React, { useMemo } from 'react';

import { Controller } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import useHashmapConverter from 'hooks/useHashmapConverter';

import { useProjectTreeStore } from 'store/projectContract.store';

import { useQueryClustersList } from 'api/queries/clustersList.query';

import { ProgramStatusUrlParams } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramStatusSummaryReport/programStatusSummaryReportTypes';
import { Select } from 'components/DesignSystem/Select';

export const ClusterSelect = ({ methods, name }) => {
    const hashcode = Object.values(useParams<ProgramStatusUrlParams>()).filter(Boolean).join(',');
    const { idList } = useHashmapConverter(hashcode);
    const { project } = useProjectTreeStore();
    const { data, isFetching } = useQueryClustersList({ idList, projectId: project?.id, compare: 'ITSELF' });

    const options = useMemo<ISelectOption<number>[]>(
        () =>
            data
                ? data.clusterList.map((item) => ({
                      label: item.clusterName,
                      value: item.clusterId,
                  }))
                : [],
        [data],
    );

    const handleChange = (value: ISelectOption<number> | null) => {
        methods?.setValue(name, value ? value.value : null, { shouldDirty: true });
    };

    const handleValue = (value) => {
        if (!value) {
            return null;
        }

        return (
            data?.clusterList
                .map((item) => ({ label: item.clusterName, value: item.clusterId }))
                .find((item) => item.value === value) || null
        );
    };

    return (
        <Controller
            render={({ field }) => (
                <Select<ISelectOption<number>>
                    {...field}
                    options={options}
                    isClearable={true}
                    isLoading={isFetching}
                    onChange={handleChange}
                    value={handleValue(field.value)}
                    placeholder={'Select cluster or start typing its name...'}
                />
            )}
            name={name}
            control={methods?.control}
        />
    );
};
